export function formatLocationString({ location }) {
  const country = location?.country ?? null;
  const region = location?.region ?? null;
  const city = location?.city ?? null;

  const locationString = Array.from(new Set([city, region, country]))
    .filter(Boolean)
    .join(", ");

  return locationString;
}
